module.exports = __webpack_public_path__ + "files/5c23345d9bfe71914b8158861fe49ff0.png";